export var HomeSection;
(function (HomeSection) {
    HomeSection["Editor"] = "Editor";
    HomeSection["Lobbies"] = "Lobbies";
})(HomeSection || (HomeSection = {}));
